import { PlanTypes, PlanTypesDisplay, PlanVMNewTypesDisplay } from 'mbs-ui-shared@models/PlanTypes.enum';
import { PlanInfo } from 'mbs-ui-shared@models/backup/plan-info-model';
import { RecoveryStatus } from 'mbs-ui-shared@models/backup/recovery-status.enum';

export class PlansUtil {
  public static getIcon(type: PlanTypes): string {
    switch (+type) {
      case PlanTypes.NA:
        return 'ico ico-question-circle';
      case PlanTypes.Plan:
      case PlanTypes.RestorePlan:
        return 'ico ico-file';
      case PlanTypes.BackupDiskImagePlan:
      case PlanTypes.RestoreDiskImagePlan:
        return 'ico ico-imagebased';
      case PlanTypes.DataBasePlan:
      case PlanTypes.RestoreDataBasePlan:
        return 'ico ico-databased';
      case PlanTypes.ExchangePlan:
      case PlanTypes.RestoreExchangePlan:
        return 'ico ico-exchange';
      case PlanTypes.BackupProxmox:
      case PlanTypes.RestoreProxmox:
        return 'ico ico-proxmox';
      case PlanTypes.BackupVMware:
      case PlanTypes.RestoreVMware:
      case PlanTypes.RestoreVMwareToCustom:
        return 'ico ico-vmware';
      case PlanTypes.BackupHyperV:
      case PlanTypes.RestoreHyperV:
      case PlanTypes.RestoreHyperVToCustom:
        return 'ico ico-hyperv';
      case PlanTypes.ConsistencyCheck:
        return 'ico ico-consistencycheck';
      default:
        return 'ico ico-file';
    }
  }

  public static getName(type: PlanTypes): string {
    return PlanTypesDisplay[type] || PlanVMNewTypesDisplay[type] || '';
  }

  public static isPlanRunning(plan: PlanInfo): boolean {
    return [RecoveryStatus.Started, RecoveryStatus.Running].includes(plan?.lastRunInfo?.status);
  }
  public static isOverdue(plan: PlanInfo): boolean {
    return !this.isPlanRunning(plan) && plan?.isOverdue;
  }

  public static extendedLastInfoStatus(plan: PlanInfo): RecoveryStatus {
    return this.isOverdue(plan) ? RecoveryStatus.Overdue : plan.lastRunInfo?.status;
  }

  public static getElapsedWithoutZeroDay(elapsed: string): string {
    if (!elapsed || elapsed === '00:00:00') return '';

    if (/\d.\d\d:\d\d:\d\d/.test(elapsed)) {
      const strArr = elapsed.split('.');
      const days = +strArr[0];

      return !days ? strArr[1] : `${strArr[0]} ${+strArr[0] === 1 ? 'day' : 'days'} ${strArr[1]}`;
    }

    return /\d\d:\d\d:\d\d.\d/.test(elapsed) ? elapsed.split('.')[0] : elapsed;
  }

  public static getElapsed(elapsed: string): string {
    if (!elapsed || elapsed === '00:00:00') return '';

    if (/\d.\d\d:\d\d:\d\d/.test(elapsed)) {
      const strArr = elapsed.split('.');
      return `${strArr[0]} ${+strArr[0] === 1 ? 'day' : 'days'} ${strArr[1]}`;
    }

    if (/\d\d:\d\d:\d\d.\d/.test(elapsed)) {
      const strArr = elapsed.split('.');
      return `0 days ${strArr[0]}`;
    }

    return `0 days ${elapsed}`;
  }
}
